
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Sie treffen einen infizierten Kollegen. Dieser ist ansteckend, weist jedoch noch
keine Symptome auf. Sie halten sich beide nicht an die Abstands- und
Hygieneregeln. `}<strong parentName="p">{`Sie sind jetzt angesteckt!`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;